import * as React from 'react'
import { useCustomerApi } from './useCustomerApi'
import { CurrentCustomerContext } from 'contexts/CurrentCustomerContext'
import { updateHealthInConnectorList } from 'utils'
import { useLogger } from './useLogger'

const HEALTH_STATUS_INTERVAL = 30 * 1000 // 30 seconds

export const useCustomerHealthSync = (customerAgencyId: string) => {
  const { logError } = useLogger()
  const { state, dispatch } = React.useContext(CurrentCustomerContext)

  const { getHealthInfoForCustomer } = useCustomerApi()

  // set up timers to sync the connector health info
  React.useEffect(() => {
    const syncHealthInfo = () => {
      getHealthInfoForCustomer(customerAgencyId)
        .then(response => {
          if (response === null) return

          if (response.status === 200) {
            if (state.currentCustomer === null) return

            const updatedConnectors = updateHealthInConnectorList(
              state.currentCustomer.connectorList,
              response.data,
            )

            dispatch({
              type: 'UpdateConnectorHealthInfo',
              payload: updatedConnectors,
            })
          }
        })
        .catch(error => {
          logError(error)
        })
    }

    syncHealthInfo()
    const interval = setInterval(() => {
      syncHealthInfo()
    }, HEALTH_STATUS_INTERVAL)

    return () => {
      clearInterval(interval)
    }
    // every time we get a new API push then refetch
  }, [customerAgencyId, state.loadingState.lastApiReceiveAt])
}
